// src/components/common/ScrollToTop.tsx

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { forceScrollToTop } from '../../utils/scrollReset';

/**
 * Component that aggressively enforces scroll reset on route changes
 * Add this component in your App.tsx file inside the Router component
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const prevPathRef = useRef<string>("");
  
  useEffect(() => {
    // Only scroll to top if the path has changed
    if (prevPathRef.current !== pathname) {
      // Use our aggressive scroll reset utility
      forceScrollToTop();
      
      // Update previous path reference
      prevPathRef.current = pathname;
    }
  }, [pathname]);

  // Also listen for location change events
  useEffect(() => {
    const handleLocationChange = () => {
      forceScrollToTop();
    };
    
    // Listen for our custom location change events
    window.addEventListener('locationchange', handleLocationChange);
    
    return () => {
      window.removeEventListener('locationchange', handleLocationChange);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
